import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Map } from 'immutable';
import moment from 'moment';
import { SIMPLE_DATETIME_FORMAT } from '../../config/app_config';

const userTypeMap = new Map({
  1: 'Datarista System Admin',
  2: 'Provider Admin',
  3: 'Provider Sales Op',
  4: 'Provider Technical',
  5: 'Provider Billing',
});

export default class UsersIndex extends React.Component {
  static propTypes = {
    activeUser: PropTypes.object.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    users: PropTypes.object.isRequired,
    setUserSelected: PropTypes.func.isRequired,
    toggleActiveUser: PropTypes.func.isRequired,
    toggleDialog: PropTypes.func.isRequired,
  };

  // update the list component if a new user is added to list
  shouldComponentUpdate = nextProps => {
    const { users, activeUser } = this.props;
    const prevUsers = users;
    const prevActiveUser = activeUser;
    const nextUsers = nextProps.users;
    const nextActiveUser = nextProps.activeUser;
    if (prevUsers.size !== nextUsers.size) {
      return true;
    }
    if (prevActiveUser !== nextActiveUser) {
      return true;
    }
    return false;
  };

  getUserDescription = typeId => userTypeMap.get(typeId.toString());

  renderUsers = user => {
    const {
      activeUser,
      isSuperAdmin,
      isProviderAdmin,
      setUserSelected,
      toggleActiveUser,
      toggleDialog,
    } = this.props;
    const isActive = activeUser.id === user.id;
    return (
      <tr
        key={user.id}
        className={`hoverable ${isActive ? 'active' : ''}`}
        onClick={() => {
          toggleActiveUser(user);
        }}
      >
        <td>
          {user.firstName} {user.lastName}
        </td>
        <td>{this.getUserDescription(user.userTypeId)}</td>
        <td>{user.email}</td>
        <td>{user.phone}</td>
        <td>
          {user.lastLoginDate ? moment(user.lastLoginDate).format(SIMPLE_DATETIME_FORMAT) : ''}
        </td>
        {isSuperAdmin ? <td>{user.status === 1 ? 'Enabled' : 'Disabled'}</td> : null}
        {isSuperAdmin ? <td>{user.isPrimary ? 'Yes' : 'No'}</td> : null}
        {isProviderAdmin || isSuperAdmin ? (
          <td>
            <Link to={`/users/${user.accountId}/edit/${user.id}`}>
              <button className="btn btn-sm btn-primary-outline">Edit</button>
            </Link>
          </td>
        ) : null}
        {isProviderAdmin || isSuperAdmin ? (
          <td>
            <button
              className="btn btn-sm btn-primary-outline"
              onClick={() => {
                setUserSelected(user);
                toggleDialog('resendInviteDialog');
              }}
            >
              Invite
            </button>
          </td>
        ) : null}
      </tr>
    );
  };

  render() {
    const { isProviderAdmin, isSuperAdmin, users } = this.props;

    return (
      <div className="row">
        <div className="col-md-12">
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Access Level</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Last Login Date</th>
                {isSuperAdmin ? <th>Enabled</th> : null}
                {isSuperAdmin ? <th>Primary?</th> : null}
                {isProviderAdmin || isSuperAdmin ? <th>Edit</th> : null}
                {isProviderAdmin || isSuperAdmin ? <th>Invite</th> : null}
              </tr>
            </thead>
            <tbody>{users.map(this.renderUsers)}</tbody>
          </table>
        </div>
      </div>
    );
  }
}
